import { Pipe, PipeTransform } from '@angular/core';
import { BabelService } from 'src/app/shared/data-service/babel.service';

@Pipe({
    name: 'translate'
})
export class TranslationPipe implements PipeTransform {

    constructor() { }

    transform(value: string): string {
        return BabelService.translate(value).replace(/\$lineBreak\$/g, '\r\n').replace(/\\r\\n/g, '\r\n');
    }
}
